<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17.285"
        height="19.789"
        viewBox="0 0 17.285 19.789"
    >
        <g
            id="Gruppe_380"
            data-name="Gruppe 380"
            transform="translate(0.996 0.059)"
        >
            <path
                id="Pfad_14"
                data-name="Pfad 14"
                d="M13.662.1,7.09,3.879V14.064l6.572,3.779c.543.311,1.175-.151,1.175-.856V.956C14.837.25,14.2-.213,13.662.1Z"
                transform="translate(-0.785 -0.001)"
                :class="fillClass + ' transition-fill'"
            />
            <path
                id="Pfad_15"
                data-name="Pfad 15"
                d="M4.485,5.727.8,5.734a.885.885,0,0,0-.8.881c0,.021,0,.043,0,.064v7.664c0,.019,0,.041,0,.063a.872.872,0,0,0,.794.869H4.484V5.726Z"
                transform="translate(0.004 -1.446)"
                :class="fillClass + ' transition-fill'"
            />
            <g
                id="Rechteck_1647"
                data-name="Rechteck 1647"
                transform="translate(-0.996 1.869) rotate(-40)"
                :class="fillClass + ' transition-fill'"
                stroke="#212227"
                stroke-width="1"
            >
                <rect width="3" height="23.315" stroke="none" />
                <rect x="0.5" y="0.5" width="2" height="22.315" fill="none" />
            </g>
        </g>
    </svg>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "VolumeCanceledIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
        },
    },
});
</script>
